import React from "react";
import "./KeyPoints.css"

function KeyPoints() {
    // const data = props.data;

    let news_points_json = {};
    let keyPointsList = [];
    let summary = "";
    let entitiesList = [];
    let figuresList = [];
    let sentiment = "";


    // if (data != null) {
    //     news_points_json = JSON.parse(data.news_points);
    //     console.log(news_points_json);
    //     keyPointsList = news_points_json.keypoints.split('\n');
    //     summary = news_points_json.summary;
    //     entitiesList = news_points_json.entities.split('\n');
    //     figuresList = news_points_json.figures.split('\n');
    //     sentiment = news_points_json.sentiment;
    //     console.log(keyPointsList);
    // }

    const mockSentences = [
  "The purple elephants danced gracefully on the moonlit marshmallow.",
  "In a parallel universe, penguins drive flying saucers to attend intergalactic tea parties.",
  "The talking tomato taught me how to juggle watermelons underwater.",
  "Quantum chickens play chess with time-traveling hedgehogs in the backyard.",
  "My pet rock has a secret talent for reciting Shakespearean sonnets in pig Latin.",
  "The rainbow-colored giraffe wore sunglasses to protect its eyes from the disco ball.",
  "Wizards prefer texting spells instead of casting them with wands.",
  "Marshmallow clouds rained chocolate drops over the candy cane meadow.",
  "Unicorns moonlight as professional stand-up comedians in enchanted forests.",
  "The robotic parrot recited binary code poetry to the techno-savvy squirrels."
];

    keyPointsList = mockSentences;

    return (
        <>
            <ul>
              {keyPointsList.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
            <p>{summary}</p>
        </>
    );
}

export default KeyPoints;
